export default __webpack_public_path__ + "static/media/warning--ruts--g1.01bce4e7.png";